/**
 * DomainAwareHome - Routes users based on domain and authentication state
 * 
 * Domain Routing Logic:
 * - virtual-hardhat.com / www.virtual-hardhat.com: Show marketing LandingPage
 * - app.virtual-hardhat.com: 
 *   - If authenticated: Redirect to /command-center
 *   - If not authenticated: Redirect to /login
 * 
 * This enables the same vh-web app to serve both the marketing site and the dashboard.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProviderUnified';
import LandingPage from '../pages/LandingPage';
import DarkSuspenseFallback from './DarkSuspenseFallback';

// Marketing domains that should show the landing page
const MARKETING_DOMAINS = [
  'virtual-hardhat.com',
  'www.virtual-hardhat.com',
  'localhost', // For local development
  '127.0.0.1', // For local development
];

// App domain that should redirect to dashboard/login
const APP_DOMAIN = 'app.virtual-hardhat.com';

/**
 * Check if current hostname is a marketing domain
 */
function isMarketingDomain() {
  const hostname = window.location.hostname;
  return MARKETING_DOMAINS.some(domain => 
    hostname === domain || hostname.endsWith(`.${domain}`)
  );
}

/**
 * Check if current hostname is the app domain
 */
function isAppDomain() {
  const hostname = window.location.hostname;
  return hostname === APP_DOMAIN;
}

export default function DomainAwareHome() {
  const { user, loading } = useAuth();

  // Show loader while checking auth state
  if (loading) {
    return <DarkSuspenseFallback />;
  }

  // On app.virtual-hardhat.com, redirect based on auth state
  if (isAppDomain()) {
    if (user) {
      // Authenticated users go to their dashboard
      return <Navigate to="/command-center" replace />;
    } else {
      // Unauthenticated users go to login
      return <Navigate to="/login" replace />;
    }
  }

  // On marketing domains (virtual-hardhat.com, www.virtual-hardhat.com, localhost),
  // always show the landing page
  return <LandingPage />;
}


